import { useEffect } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { usePostHog } from '@posthog/react';
import { useAppRouterInitial } from './routerBase';

function PostHogPageViewTracker() {
  const posthog = usePostHog();
  const location = useRouterState({ select: (s) => s.location });

  useEffect(() => {
    posthog.capture('$pageview', { $current_url: window.location.href });
  }, [posthog, location.pathname, location.search]);

  return null;
}

// Exported for direct testing (AppShell.test.tsx) without needing a full
// router context around it.
export function PostHogUserIdentifier() {
  const posthog = usePostHog();
  const { currentUser } = useAppRouterInitial();

  useEffect(() => {
    if (!currentUser) return;

    // Only include properties that actually exist — identify() would
    // otherwise happily set literal "undefined" strings on the person.
    const properties: Record<string, string> = { role: currentUser.role };
    if (currentUser.email) properties.email = currentUser.email;
    if (currentUser.name) properties.name = currentUser.name;

    posthog.identify(String(currentUser.id), properties);
  }, [posthog, currentUser]);

  return null;
}

export function AppShell() {
  return (
    <>
      <PostHogPageViewTracker />
      <PostHogUserIdentifier />
      <Outlet />
    </>
  );
}
